<template>
  <div v-once></div>
</template>
<script>
import { pleaseWait } from "please-wait";
import "please-wait/build/please-wait.css";
export default {
  data() {
    return {
      pleaseWaitInstance: null
    };
  },
  props: ["isLoading"],
  watch: {
    isLoading: {
      handler(isLoading) {
        if (isLoading) {
          this.open();
        } else {
          this.close();
        }
      },
      immediate: true
    }
  },
  methods: {
    open() {
      // Attaching a `pleaseWaitInstance` property (no need to declare)...
      if (!this.pleaseWaitInstance) {
        this.pleaseWaitInstance = pleaseWait({
          logo: require("@/assets/Loading.png"),
          backgroundColor: "#fff",
          loadingHtml: ""
        });
      }
    },
    close() {
      if (this.pleaseWaitInstance) {
        this.pleaseWaitInstance.finish();
        this.pleaseWaitInstance = null;
      }
    }
  }
};
</script>